import { render } from "./CreateAuthorization.vue?vue&type=template&id=51cbb693"
import script from "./CreateAuthorization.vue?vue&type=script&lang=js"
export * from "./CreateAuthorization.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__